// Full-screen comments popup for mobile.
import React from "react";
import { Popup, View, Page, Navbar, NavRight, Link } from "framework7-react";

import CommentsPanel from "./CommentsPanel";

const CommentsPopup = ({ opened, onClose, commentableType, commentableId, title }) => {
  return (
    <Popup className="comments-popup" opened={!!opened} onPopupClosed={onClose} tabletFullscreen>
      <View>
        <Page>
          <Navbar title={title || "Comments"}>
            <NavRight>
              <Link popupClose>Close</Link>
            </NavRight>
          </Navbar>
          {opened && commentableType && commentableId && (
            <CommentsPanel commentableType={commentableType} commentableId={commentableId} />
          )}
        </Page>
      </View>
    </Popup>
  );
};

export default CommentsPopup;
